var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        { attrs: { outlined: "", elevation: "1" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", dense: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v("Completion Report")]),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { small: "", text: "", color: "white" },
                  on: {
                    click: function($event) {
                      return _vm.printReport(_vm.reportId)
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-printer")
                  ]),
                  _vm._v(" Print ")
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: {
                    small: "",
                    text: "",
                    color: "white",
                    to: "/completion-reports"
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("mdi-arrow-left")
                  ]),
                  _vm._v(" Back ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                    _c("strong", [_vm._v("Reference No")]),
                    _c("div", { staticClass: "mt-1" }, [
                      _vm._v(_vm._s(_vm.inputs.ref_no || "-"))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                    _c("strong", [_vm._v("Date")]),
                    _c("div", { staticClass: "mt-1" }, [
                      _vm._v(_vm._s(_vm.inputs.date || "-"))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                    _c("strong", [_vm._v("Customer ID")]),
                    _c("div", { staticClass: "mt-1" }, [
                      _vm._v(_vm._s(_vm.inputs.customer_id || "-"))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("strong", [_vm._v("Project Name")]),
                    _c("div", { staticClass: "mt-1" }, [
                      _vm._v(_vm._s(_vm.inputs.project_name || "-"))
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("strong", [_vm._v("Description")]),
                    _c("div", { staticClass: "mt-1 pre-wrap" }, [
                      _vm._v(_vm._s(_vm.inputs.description || "-"))
                    ])
                  ]),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("strong", [_vm._v("Scope of Works")]),
                      _c(
                        "v-list",
                        { staticClass: "mt-2", attrs: { dense: "" } },
                        [
                          _vm._l(_vm.inputs.scope_of_works, function(
                            item,
                            index
                          ) {
                            return _c(
                              "v-list-item",
                              { key: "scope-" + index },
                              [
                                _c(
                                  "v-list-item-content",
                                  [
                                    _c("v-list-item-title", [
                                      _vm._v(
                                        _vm._s(index + 1) + ". " + _vm._s(item)
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          }),
                          !_vm.inputs.scope_of_works.length
                            ? _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "grey--text" },
                                        [_vm._v("No scope of works provided")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("strong", [_vm._v("Work Completed")]),
                    _c("div", { staticClass: "mt-1 pre-wrap" }, [
                      _vm._v(
                        _vm._s(_vm.inputs.work_completed.join("\n") || "-")
                      )
                    ])
                  ]),
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("strong", [_vm._v("Conclusion")]),
                    _c("div", { staticClass: "mt-1 pre-wrap" }, [
                      _vm._v(_vm._s(_vm.inputs.conclusion || "-"))
                    ])
                  ]),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("strong", [_vm._v("Images")]),
                      _vm._l(_vm.imageRows, function(row, rowIndex) {
                        return _c(
                          "v-row",
                          {
                            key: "row-" + rowIndex,
                            attrs: { dense: "", align: "start" }
                          },
                          _vm._l(row, function(img, i) {
                            return _c(
                              "v-col",
                              {
                                key: "img-" + rowIndex + "-" + i,
                                attrs: {
                                  cols: Math.floor(
                                    _vm.spanToNumber(img.span) * 12
                                  )
                                }
                              },
                              [
                                img.preview
                                  ? _c("v-img", {
                                      staticClass: "mt-2 grey lighten-4",
                                      attrs: {
                                        src: img.preview,
                                        "max-height": "200",
                                        contain: ""
                                      }
                                    })
                                  : _c(
                                      "div",
                                      { staticClass: "grey--text mt-2" },
                                      [_vm._v("No image provided")]
                                    ),
                                _c(
                                  "div",
                                  { staticClass: "text-caption mt-1" },
                                  [_vm._v(_vm._s(img.name || "No name"))]
                                )
                              ],
                              1
                            )
                          }),
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }